import { FlowComponent } from '../../../modules/flow/flow.component';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '../../services/store/shared-store/shared-storage.service';

@Injectable()
export class DataChangesGuard implements CanDeactivate<FlowComponent> {
  constructor(private sharedService: SharedService) {}

  canDeactivate(
    component: FlowComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    if (component) {
      if (currentRoute.params['entityType'] === 'TEMPLATE') {
          component.saveFlowStatus = false;
      }
      if (component.saveFlowStatus) {
        const flowChanged: Boolean = component.sharedService.getIsFlowChanged();
        const activeForm: any = component.activeFormService.getActiveForm();
        const isFormActive: Boolean = activeForm && activeForm.dirty && activeForm.touched;
        const changedForm: Boolean = component.activeFormService.getIsFormChanged();
        const flowEdited = (flowChanged && ((!activeForm && changedForm)) || isFormActive);
        const newNode = component.isNewNode;

        if (flowEdited || newNode || changedForm) {
          component.nextPage = nextState.url;
          newNode ? component.showResetNewNodeDialog() : component.showSaveDialog();
          return false;
        } else {
          this.setEnvData();
          return true;
        }
      } else {
        component.nextPage = null;
        component.saveFlowStatus = true;
        this.setEnvData();
        return true;
      }
    } else {
      this.setEnvData();
      return true;
    }
  }

  setEnvData() {
    // @ts-ignore
    const { key, value, callback } = this.sharedService.envChanged;
    if (key && value && callback) {
      this.sharedService.setRequestData();
    }
  }
}
